(function () {
  function closeFaqItem(item) {
    const trigger = item.querySelector(".el-faq-section__trigger");
    const content = item.querySelector(".el-faq-section__answer");
    if (!content) return;

    content.style.height = `${content.scrollHeight}px`;
    void content.offsetHeight;
    item.classList.remove("is-open");
    content.style.height = "0px";
    if (trigger) trigger.setAttribute("aria-expanded", "false");
  }

  function openFaqItem(item) {
    const trigger = item.querySelector(".el-faq-section__trigger");
    const content = item.querySelector(".el-faq-section__answer");
    if (!content) return;

    item.classList.add("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");

    content.style.height = "auto";
    const fullHeight = content.scrollHeight;
    content.style.height = "0px";
    void content.offsetHeight;
    content.style.height = `${fullHeight}px`;
  }

  function initFaqItems(section) {
    const items = section.querySelectorAll("[data-el-faq-item]");

    items.forEach((item) => {
      const trigger = item.querySelector(".el-faq-section__trigger");
      const content = item.querySelector(".el-faq-section__answer");

      if (!trigger || !content || item.dataset.initialized === "true") return;
      item.dataset.initialized = "true";

      content.style.height = "0px";
      content.style.overflow = "hidden";

      trigger.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        const panel = item.closest("[data-el-faq-panel]");
        const tabId = panel?.dataset.elFaqPanel;

        if (tabId) {
          section
            .querySelectorAll(`[data-el-faq-panel="${tabId}"] [data-el-faq-item].is-open`)
            .forEach((openItem) => {
              if (openItem !== item) closeFaqItem(openItem);
            });
        }

        if (isOpen) {
          closeFaqItem(item);
          return;
        }

        openFaqItem(item);
      });
    });
  }

  function setActiveTab(section, tabId) {
    const tabs = section.querySelectorAll("[data-el-faq-tab]");
    const panels = section.querySelectorAll("[data-el-faq-panel]");

    tabs.forEach((tab) => {
      const isActive = tab.dataset.elFaqTab === tabId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.elFaqPanel === tabId;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;

      if (!isActive) {
        panel.querySelectorAll("[data-el-faq-item].is-open").forEach(closeFaqItem);
      }
    });
  }

  function initTabs(section) {
    const tabs = section.querySelectorAll("[data-el-faq-tab]");
    const panels = section.querySelectorAll("[data-el-faq-panel]");

    if (!tabs.length || !panels.length) return;

    const defaultTab = tabs[0]?.dataset.elFaqTab;
    if (defaultTab) setActiveTab(section, defaultTab);

    tabs.forEach((tab) => {
      if (tab.dataset.initialized === "true") return;
      tab.dataset.initialized = "true";

      tab.addEventListener("click", () => {
        setActiveTab(section, tab.dataset.elFaqTab);
      });
    });
  }

  function initFaqSection(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-el-faq-section]").forEach((section) => {
      initTabs(section);
      initFaqItems(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initFaqSection());
  } else {
    initFaqSection();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initFaqSection(event.target);
  });
})();
